import {
  MdHome,
  MdList,
  MdPhone,
  MdGroup,
  MdSettings,
  MdCampaign,
  MdSend,
  MdMessage,
  MdPerson,
  MdCloudUpload,
  MdAccountBalance,
  MdShoppingCart,
  MdCardMembership,
  MdAccountTree,
  MdTimeline,
  MdDeviceHub,
} from "react-icons/md";

// Admin Imports

// NFT Imports
import EventView from "views/admin/event_view";

// Main Imports

import CreateEditEvent from "views/admin/event_create_edit";

import ApplicationsCalendar from "views/admin/calendar";
import WhatsappTemplateCreator from "views/admin/whatsapp-template";
import WhatsappTemplatesList from "views/admin/whatsapp-template/WhatsappTemplatesList";
import ChatWhatsAppLike  from "views/admin/whatsapp-template/send-messages";
import PhoneNumbersList from "views/admin/whatsapp-template/phone-numbers-list";
import MarketingMessagesList from "views/admin/whatsapp-template/marketing-messages-list";
import MarketingSend from "views/admin/whatsapp-template/marketing-send";
import PhoneGroupsManager from "views/admin/whatsapp-template/phone-groups-manager";
import ModernPhoneGroupsManager from "views/admin/whatsapp-template/ModernPhoneGroupsManager";
import AutomatedFlowsManager from "views/admin/whatsapp-template/automated-flows-manager";
import WhatsAppFlowBuilder from "views/admin/whatsapp-template/WhatsAppFlowBuilder";
import AutomatedFlowBuilder from "views/admin/whatsapp-template/AutomatedFlowBuilder";
import AutomatedFlowsList from "views/admin/whatsapp-template/AutomatedFlowsList";
import BusinessPersonalitySettings from "views/admin/whatsapp-template/business-personality-settings";
import ModernBusinessPersonalitySettings from "views/admin/whatsapp-template/ModernBusinessPersonalitySettings";
import PhoneSettings from "views/admin/whatsapp-template/phone-settings";
import UserSettings from "views/admin/user-settings";
import ModernUserSettings from "views/admin/user-settings/ModernUserSettings";
import TestUserSettings from "views/admin/user-settings/TestUserSettings";
import ModernDashboard from "views/admin/default/ModernDashboard";
import FileUpload from "views/admin/file-upload";
import Finance from "views/admin/finance";
import { WhatsAppSendMessageRedirect } from "components/WhatsAppSendMessageRedirect";
import Ecommerce from "views/admin/ecommerce";
import Membership from "views/admin/membership";

const routes = [
  
  {
    name: "Dashboard",
    path: "/",
    layout: "/events",
    component: <ModernDashboard />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdHome size="20px" />,
  },
  {
    name: "Create Event",
    layout: "/events",
    path: "/create",
    component: <CreateEditEvent />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication

  },
  {
    name: "EditEvent",
    layout: "/events",
    path: "/create/:id",
    component: <CreateEditEvent />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
  },
  {
    name: "confim meetings",
    layout: "/events",
    path: "/meeting",
    component: <ApplicationsCalendar />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
  },
  {
    name: "whatsapp Create Template",
    layout: "/events",
    path: "/whatsapp-template",
    component: <WhatsappTemplateCreator />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
  },
  {
    name: "whatsapp Edit Template",
    layout: "/events",
    path: "/whatsapp-template/edit/:templateId",
    component: <WhatsappTemplateCreator />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
  },
  {
    name: "whatsapp List Templates",
    layout: "/events",
    path: "/whatsapp-list-template",
    component: <WhatsappTemplatesList />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdList size="20px" />,
  },
  {
    name: "Send Message",
    layout: "/events",
    path: "/conversations",
    component: <PhoneNumbersList />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdMessage size="20px" />,
  },
  {
    name: "Manage Groups",
    layout: "/events",
    path: "/whatsapp-phone-groups-manager",
    component: <ModernPhoneGroupsManager />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdGroup size="20px" />,
  },
  {
    name: "Create Campaign",
    layout: "/events",
    path: "/whatsapp-marketing-list",
    component: <MarketingMessagesList />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdCampaign size="20px" />,
  },
  {
    name: "Upload Media",
    layout: "/events",
    path: "/file-upload",
    component: <FileUpload />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdCloudUpload size="20px" />,
  },
  {
    name: "Flows Manager",
    layout: "/events",
    path: "/whatsapp-automated-flows-manager",
    component: <AutomatedFlowsManager />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
    icon: <MdSettings size="20px" />,
  },
  {
    name: "Flow Builder",
    layout: "/events",
    path: "/whatsapp-flow-builder",
    component: <WhatsAppFlowBuilder />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdAccountTree size="20px" />,
  },
  {
    name: "Automated Flows",
    layout: "/events",
    path: "/automated-flows-list",
    component: <AutomatedFlowsList />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdTimeline size="20px" />,
  },
  {
    name: "Automated Flow Builder",
    layout: "/events",
    path: "/automated-flow-builder",
    component: <AutomatedFlowBuilder />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
  },
  {
    name: "Business Personality Settings",
    layout: "/events",
    path: "/business-personality-settings",
    component: <ModernBusinessPersonalitySettings />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdSettings size="20px" />,
  },
  {
    name: "Phone Settings",
    layout: "/events",
    path: "/phone-settings",
    component: <PhoneSettings />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdPhone size="20px" />,
  },
  {
    name: "whatsapp Marketing Send",
    layout: "/events",
    path: "/whatsapp-marketing-send",
    component: <MarketingSend />,
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
  },
  {
    name: "Settings",
    layout: "/events",
    path: "/user-settings",
    component: <ModernUserSettings />,
    collapse: false,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdPerson size="20px" />,
  },
  {
    name: "whatsapp send Messages",
    layout: "/events",
    path: "/whatsapp-send-message",
    component: (
      <ChatWhatsAppLike
        contactId={(() => {
          // Get customer phone from session storage if available, otherwise use a default
          try {
            const storedCustomer = sessionStorage.getItem('selectedCustomer');
            if (storedCustomer) {
              const customer = JSON.parse(storedCustomer);
              return customer.phone || "";
            }
          } catch (e) {
            // Error getting customer from session storage - silently continue
          }
          return "";
        })()}
        currentUserId="agent-42"
        businessId="YOUR_BUSINESS_ID"
        apiBaseUrl="https://api.frontdesk24.com/api"
      />
    ),
    collapse: false,
    isShow: false,
    requireAuth: true, // Requires authentication
    icon: <MdMessage size="20px" />,
  },
    {
      name: "whatsapp send Messages - Messages Tab",
      layout: "/events",
      path: "/whatsapp-send-message/:phoneNumber/messages",
      component: (
        <ChatWhatsAppLike
          contactId={(() => {
            try {
              const phoneFromUrl = window.location.pathname.split('/')[3];
              if (phoneFromUrl && phoneFromUrl !== 'whatsapp-send-message') {
                return phoneFromUrl;
              }
              const storedCustomer = sessionStorage.getItem('selectedCustomer');
              if (storedCustomer) {
                const customer = JSON.parse(storedCustomer);
                return customer.phone || "";
              }
            } catch (e) {
              // Error getting customer from URL or session storage - silently continue
            }
            return "";
          })()}
          currentUserId="agent-42"
          businessId="YOUR_BUSINESS_ID"
          apiBaseUrl="https://api.frontdesk24.com/api"
        />
      ),
      collapse: false,
      isShow: false,
      requireAuth: true,
    },
    {
      name: "whatsapp send Messages - WhatsApp Calls Tab",
      layout: "/events",
      path: "/whatsapp-send-message/:phoneNumber/whatsappcalls",
      component: (
        <ChatWhatsAppLike
          contactId={(() => {
            try {
              const phoneFromUrl = window.location.pathname.split('/')[3];
              if (phoneFromUrl && phoneFromUrl !== 'whatsapp-send-message') {
                return phoneFromUrl;
              }
              const storedCustomer = sessionStorage.getItem('selectedCustomer');
              if (storedCustomer) {
                const customer = JSON.parse(storedCustomer);
                return customer.phone || "";
              }
            } catch (e) {
              // Error getting customer from URL or session storage - silently continue
            }
            return "";
          })()}
          currentUserId="agent-42"
          businessId="YOUR_BUSINESS_ID"
          apiBaseUrl="https://api.frontdesk24.com/api"
        />
      ),
      collapse: false,
      isShow: false,
      requireAuth: true,
    },
    {
      name: "whatsapp send Messages - Phone Calls Tab",
      layout: "/events",
      path: "/whatsapp-send-message/:phoneNumber/phonecalls",
      component: (
        <ChatWhatsAppLike
          contactId={(() => {
            try {
              const phoneFromUrl = window.location.pathname.split('/')[3];
              if (phoneFromUrl && phoneFromUrl !== 'whatsapp-send-message') {
                return phoneFromUrl;
              }
              const storedCustomer = sessionStorage.getItem('selectedCustomer');
              if (storedCustomer) {
                const customer = JSON.parse(storedCustomer);
                return customer.phone || "";
              }
            } catch (e) {
              // Error getting customer from URL or session storage - silently continue
            }
            return "";
          })()}
          currentUserId="agent-42"
          businessId="YOUR_BUSINESS_ID"
          apiBaseUrl="https://api.frontdesk24.com/api"
        />
      ),
      collapse: false,
      isShow: false,
      requireAuth: true,
    },
    {
      name: "whatsapp send Messages - Insights Tab",
      layout: "/events",
      path: "/whatsapp-send-message/:phoneNumber/insights",
      component: (
        <ChatWhatsAppLike
          contactId={(() => {
            try {
              const phoneFromUrl = window.location.pathname.split('/')[3];
              if (phoneFromUrl && phoneFromUrl !== 'whatsapp-send-message') {
                return phoneFromUrl;
              }
              const storedCustomer = sessionStorage.getItem('selectedCustomer');
              if (storedCustomer) {
                const customer = JSON.parse(storedCustomer);
                return customer.phone || "";
              }
            } catch (e) {
              // Error getting customer from URL or session storage - silently continue
            }
            return "";
          })()}
          currentUserId="agent-42"
          businessId="YOUR_BUSINESS_ID"
          apiBaseUrl="https://api.frontdesk24.com/api"
        />
      ),
      collapse: false,
      isShow: false,
      requireAuth: true,
    },
    {
      name: "whatsapp send Messages - Recommendations Tab",
      layout: "/events",
      path: "/whatsapp-send-message/:phoneNumber/recommendations",
      component: (
        <ChatWhatsAppLike
          contactId={(() => {
            try {
              const phoneFromUrl = window.location.pathname.split('/')[3];
              if (phoneFromUrl && phoneFromUrl !== 'whatsapp-send-message') {
                return phoneFromUrl;
              }
              const storedCustomer = sessionStorage.getItem('selectedCustomer');
              if (storedCustomer) {
                const customer = JSON.parse(storedCustomer);
                return customer.phone || "";
              }
            } catch (e) {
              // Error getting customer from URL or session storage - silently continue
            }
            return "";
          })()}
          currentUserId="agent-42"
          businessId="YOUR_BUSINESS_ID"
          apiBaseUrl="https://api.frontdesk24.com/api"
        />
      ),
      collapse: false,
      isShow: false,
      requireAuth: true,
    },
    {
      name: "whatsapp send Messages with Phone",
      layout: "/events",
      path: "/whatsapp-send-message/:phoneNumber",
      component: <WhatsAppSendMessageRedirect />,
      collapse: false,
      isShow: false,
      requireAuth: true,
    },
  {
    name: "Membership",
    path: "/membership",
    layout: "/events",
    component: <Membership />,
    collapse: true,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdCardMembership size="20px" />,
    items: [
      {
        name: "Plans",
        path: "/membership/plans",
        layout: "/events",
        component: <Membership />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdCardMembership size="20px" />,
      },
      {
        name: "Subscriptions",
        path: "/membership/subscriptions",
        layout: "/events",
        component: <Membership />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdCardMembership size="20px" />,
      },
      {
        name: "Members",
        path: "/membership/members",
        layout: "/events",
        component: <Membership />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdCardMembership size="20px" />,
      },
      {
        name: "Benefits",
        path: "/membership/benefits",
        layout: "/events",
        component: <Membership />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdCardMembership size="20px" />,
      },
    ],
  },
  {
    name: "C-commerce",
    path: "/ecommerce",
    layout: "/events",
    component: <Ecommerce />,
    collapse: true,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdShoppingCart size="20px" />,
    items: [
      {
        name: "Products",
        path: "/ecommerce/products",
        layout: "/events",
        component: <Ecommerce />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdShoppingCart size="20px" />,
      },
      {
        name: "Orders",
        path: "/ecommerce/orders",
        layout: "/events",
        component: <Ecommerce />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdShoppingCart size="20px" />,
      },
      {
        name: "Customers",
        path: "/ecommerce/customers",
        layout: "/events",
        component: <Ecommerce />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdShoppingCart size="20px" />,
      },
      {
        name: "Analytics",
        path: "/ecommerce/analytics",
        layout: "/events",
        component: <Ecommerce />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdShoppingCart size="20px" />,
      },
    ],
  },
  {
    name: "Finance",
    path: "/finance",
    layout: "/events",
    component: <Finance />,
    collapse: true,
    isShow: true,
    requireAuth: true, // Requires authentication
    icon: <MdAccountBalance size="20px" />,
    items: [
      {
        name: "Payments",
        path: "/finance/payments",
        layout: "/events",
        component: <Finance />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdAccountBalance size="20px" />,
      },
      {
        name: "Invoices",
        path: "/finance/invoices",
        layout: "/events",
        component: <Finance />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdAccountBalance size="20px" />,
      },
      {
        name: "Reports",
        path: "/finance/reports",
        layout: "/events",
        component: <Finance />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdAccountBalance size="20px" />,
      },
      {
        name: "Taxes",
        path: "/finance/taxes",
        layout: "/events",
        component: <Finance />,
        collapse: false,
        isShow: true,
        requireAuth: true,
        icon: <MdAccountBalance size="20px" />,
      },
    ],
  },

  /*
  {
    name: "linkedin Invitation",
    layout: "/linkedin",
    path: "/invitation",
    component: <CreateEditEvent />,
    collapse: false,
  },
  {
    name: "linkedin Message",
    layout: "/linkedin",
    path: "/message",
    component: <ApplicationsCalendar />,
    collapse: false,
  }
 */
];
export default routes;
